/** @format */
import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';

export const autoLoadingPathnames = ['/return'];

export const useAutoLoadIntercom = () => {
    const router = useRouter();

    const isEnabledByDefault = autoLoadingPathnames.some((path) =>
        router.pathname.startsWith(path)
    );

    // eslint-disable-next-line @typescript-eslint/naming-convention -- Legacy code: do not use as an example.
    const [autoEnabled, setAutoEnabled] = useState<boolean>(isEnabledByDefault);

    useEffect(() => {
        setAutoEnabled(isEnabledByDefault);
    }, [isEnabledByDefault, setAutoEnabled]);

    return autoEnabled;
};
